const topics = [
  { tag: '#奔跑吧', heat: '热播中', count: '12.8万', trend: 'up' },
  { tag: '#极限挑战', heat: '人气爆棚', count: '10.5万', trend: 'up' },
  { tag: '#乘风2024', heat: '话题不断', count: '15.2万', trend: 'up' },
  { tag: '#向往的生活', heat: '治愈慢综', count: '8.9万', trend: 'stable' },
  { tag: '#脱口秀大会', heat: '爆笑不断', count: '9.6万', trend: 'up' },
  { tag: '#这就是街舞', heat: '热血来袭', count: '11.3万', trend: 'up' },
  { tag: '#密室大逃脱', heat: '悬疑烧脑', count: '7.8万', trend: 'stable' },
  { tag: '#心动的信号', heat: '甜蜜恋爱', count: '6.5万', trend: 'up' },
  { tag: '#天赐的声音', heat: '神仙打架', count: '8.2万', trend: 'up' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4 whitespace-nowrap">
              热门话题
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              大家都在追的热门综艺话题
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-2xl mx-auto">
              实时追踪全网最热综艺话题，看看哪档节目正在刷爆你的朋友圈
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
            {topics.map((topic) => (
              <a
                key={topic.tag}
                href="#topics"
                className="group bg-background-50 border border-background-200 rounded-xl p-4 md:p-5 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {topic.tag}
                  </span>
                  <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap ${
                    topic.trend === 'up'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-secondary-100 text-secondary-600'
                  }`}>
                    {topic.heat}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-fire-line text-accent-500"></i>
                  <span>{topic.count} 讨论</span>
                  {topic.trend === 'up' && (
                    <span className="text-primary-500 flex items-center gap-0.5">
                      <i className="ri-arrow-up-line text-xs"></i>
                    </span>
                  )}
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}